'use client'
import React, { useState } from 'react'
const ReadMore = ({ children }: any) => {
  const text = children
  const [isReadMore, setIsReadMore] = useState(true)
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }
  return (
    <div>
      <p>{isReadMore ? text.slice(0, 0) : text}</p>
      <div
        onClick={toggleReadMore}
        className="btn effect-btn"
      >
        {isReadMore ? 'Read More' : 'Show Less'}
      </div>
    </div>
  )
}

export default ReadMore
